export const ENUM_PRODUCT_TYPE = {
    API: 1, // API 对接
    CPS: 2, // H5 嵌入(CPS对接)
    OFFLINE: 3, // 引导线下投保(微投)
}

export const ENUM_INSURE_JUMP_PAGE_TYPE = {
    DETAIL: 3, // 使用产品详情页
    DETAIL_AND_QUOTATION: 1, // 使用产品详情页+报价页
    TRANSFER: 2, // 使用中转页（H5嵌入、线下产品）
    LEGACY_UNSPECIFIED: 0, // 存量旧产品，未配置
}

export const ENUM_TRANSFER_H5_PAGE_TYPE = {
    GENERAL: 1, // 通用中转页
    CUSTOMIZED: 9, // 自定义中转页
}

export const COMMON_TRANSFER_PAGE_NAME = 'transfer-insurance-notify'
export const CPS_REDIRECT_PAGE_NAME = 'cps_transfer_pages'



// WEBPACK FOOTER //
// ./src/views/data-models.js